const productsMenu: any = {
  order: 16,
  id: "products",
  title: "Prodotti",
  translate: "MENU.PRODUCTS",
  type: "collapsible",
  capability: "show_menu_products",
  icon: "package",
  children: [
    {
      id: "products-list",
      title: "Lista",
      translate: "LIST",
      type: "item",
      url: "dashboard/products/list",
      capability: "show_menu_products",
    },
    {
      id: "products-costs-list",
      title: "Costi",
      translate: "COSTS",
      type: "item",
      url: "dashboard/products/costs-list",
      capability: "show_menu_products",
    },
  ],
};
export default productsMenu;
